import { Box, Button, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import {useState, useEffect} from 'react';
import { Pagination } from '../../components/Pagination';
// import { Pagination, RowPerPageHandler } from "../Pagination/index";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux"
import _ from "lodash"
import ascSortingSelected from "../../asset/image/ascSortingSelected.svg"
import descSortingSelected from "../../asset/image/descSortingSelected.svg";
import AscSort from "../../asset/image/AscSort.svg";
import DescSort from "../../asset/image/DescSort.svg";
import { PER_PAGE_ITEMS, DEFAULT_PAGE_SIZE, NEW_PER_PAGE_ITEMS } from "../../constants/Constants";
import { convertDateTimeIntoTimezone, getDecodeURI, getEncodedURI } from "../../utils/util";
import { useHistory, useLocation } from "react-router-dom";
import { getFlightTailIdUpdateData, getFlightTailIdUpdateDataCount } from "../../actions/Users/authenticateDashboard";
import FlightSchedule from "./FlightSchedule";
import Download from '../../asset/image/DownloadUsage.svg';
import { CsvParameters, downloadAsCSV } from "../../actions/Users/authenticateCsvDownload";
import DownloadCSV, {clearCsvDownload} from "../../components/DownloadCSV";
import { MMDDYYYYHMMSS_DATE_FORMAT_24_HRS } from '../../utils/constants';

const DEFAULT_PAGE = 0;
const convertToCsv = (data: any) => {
    const [_columns, ...rows] = data;
    const csvRows: any[] = [];
    rows.forEach(row => {
        csvRows.push([row[0], row[1], row[2], row[3], row[4], row[5]] )
    })
    return [['TimeStamp', 'Device Id', 'Tail Number', 'Source', 'Module', "Description"], ...csvRows]
};

const FlightsComponent = (props) => {
    const {selectedVessel, selectedVesselName, authReducer, newSummaryStartDate, newSummaryEndDate, getFlightTailIdUpdateData, getFlightTailIdUpdateDataCount, flightTailIdUpdateTable, flightTailIdUpdateTableCount} = props;
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    let _q = new Map<string, string>(Object.entries(getDecodeURI(location.search)));
    const [tableParams, setTableParams] = useState<{
        page: number;
        size: number;
        search: string;
    }>({
        page: _q.has('page') ? parseInt(_q.get('page') as string) : 1,
        size: _q.has('size') ? parseInt(_q.get('size') as string) : 10,
        search: ''
    });
    const [flightTailNumberUpdateTable, setFlightTailNumberUpdateTable] = useState<any[]>([]);
    const [count, setCount] = useState<number>(0);
    const [sortOrder, setSortOrder] = useState<string>("desc");
    const [sortColumn, setSortColumn] = useState<string>("ts");

    const doNavigate = (params) => {
        history.push({ pathname: location.pathname, search: `?${getEncodedURI(params)}` });
    }

    const handleChangePage = (event: any, newPage: number) => {
        setTableParams({ ...tableParams, page: newPage });
    };
    const handleChangeSize = (event: any) => {
        setTableParams({ ...tableParams, size: event.target.value, page: 1 });
    };

    const toggleSortOrder = (column) => {
        const newOrder = sortOrder === "desc" ? "asc" : "desc";
        handleColumnSort(column, newOrder); 
    };

    const handleColumnSort = (column: string, order: string) => {
        setSortColumn(column);
        setSortOrder(order);
    }

    useEffect(() => {
        if(selectedVessel){
            getFlightTailIdUpdateData(selectedVessel, newSummaryStartDate, newSummaryEndDate, sortColumn, sortOrder, (tableParams.page-1)*tableParams.size, tableParams.size)
        }
    }, [selectedVessel, newSummaryStartDate, newSummaryEndDate, tableParams, sortColumn, sortOrder])

    useEffect(() => {
        if(!_.isEmpty(flightTailIdUpdateTable)) {
            const data = flightTailIdUpdateTable?.hasOwnProperty('data') ? flightTailIdUpdateTable?.data : {};
            const dataArr:any = [];
            data?.rows && data?.rows?.forEach((item, i) => {
                const itemArr = data?.columns?.reduce((acc, columItem, i) => {
                    acc[columItem] = item[i];
                    return acc;
                }, {})
                dataArr.push(itemArr)
            })
            setFlightTailNumberUpdateTable(dataArr);
        }
    }, [flightTailIdUpdateTable])

    useEffect(() => {
        if(selectedVessel){
            getFlightTailIdUpdateDataCount(selectedVessel, newSummaryStartDate, newSummaryEndDate)
        }
    }, [selectedVessel, newSummaryStartDate, newSummaryEndDate])

    useEffect(() => {
        if(!_.isEmpty(flightTailIdUpdateTableCount)) {
            const data = flightTailIdUpdateTableCount?.hasOwnProperty('data') ? flightTailIdUpdateTableCount?.data : {};
            const len = data?.rows[0]?.[0] ? data.rows[0][0] : 0;
            setCount(len);
        }
    }, [flightTailIdUpdateTableCount])

    const handleDownloadReport = () => {
        const params: CsvParameters = {
            type: 'QUERY_CH',
            id : "flight-tailId-update-table",
            queryName: 'FLIGHT_TAILID_UPDATE_TABLE',
            payload: {
                k4Id: selectedVessel,
                start_time: newSummaryStartDate,
                end_time: newSummaryEndDate,
                sort_column: sortColumn,
                sort_order: sortOrder,
                page_offset: 0,
                page_size: count
            }    
        }
        dispatch(downloadAsCSV(params));
    }

    useEffect(() => {
        if (authReducer.csvDataDownloded && authReducer.csvDataDownloded.length > 0) {
            if (authReducer.csvDownloadId === 'flight-tailId-update-table') {
                const [columns, ...rows] = authReducer.csvDataDownloded;
                DownloadCSV(convertToCsv([columns, ...rows])
                );
                return () => {
                    dispatch(clearCsvDownload())
                }
            }
        }
    }, [authReducer.csvDataDownloded])
    
    return(
        <Grid style={{padding: "0px 16px 0px 16px", overflowY: "scroll", height: "calc(100vh - 185px)"}} >
            <Grid className="alignTopbarItemsCenter">
                <Grid className="vessel_summary_product_name productName" style={{margin: '16px auto 16px 16px'}}>
                    {`Tail Number History`}
                </Grid>
                <div className="download-summary-btn margin-left-auto" onClick={handleDownloadReport}><img className="downloadImg" src={Download} alt="" /><Button>Download</Button></div>
            </Grid>
            <Grid>
                <Grid>
                    <Pagination count={count} onPageChange={handleChangePage} page={tableParams.page} rowsPerPage={tableParams.size} onRowsPerPageChange={handleChangeSize} />
                </Grid>
                <TableContainer className="usageReports-FleetDashboard loginHistory-tableContainer">
                    <Table aria-label="simple table">
                        <TableHead className="usageReports-tableHead config-tableRow">
                          <TableRow className="UsageReports-tableRow login-tableRow">
                          <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell new-summary-left">
                                <span style={{ whiteSpace: "nowrap" }} className="align-items-center justifyContenetCenter">
                                    <span className="login-history-dp-name font-wt-900" onClick={() => toggleSortOrder("ts")}>TIMESTAMP</span>
                                    <Grid className="sort-icon-margin">
                                        <img src={sortColumn === "ts" && sortOrder === "asc" ? ascSortingSelected : AscSort}
                                            className="ascendingOrderIcon sortingImages" onClick={() => handleColumnSort("ts", "asc")}/>
                                        <img src={sortColumn === "ts" && sortOrder === "desc" ? descSortingSelected : DescSort}
                                            className="sortingImages" onClick={() => handleColumnSort("ts", "desc")}/>
                                    </Grid>
                                </span>
                            </TableCell>
                            <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell new-summary-left">
                                <span style={{ whiteSpace: "nowrap" }} className="align-items-center justifyContenetCenter">
                                    <span className="login-history-dp-name font-wt-900" onClick={() => toggleSortOrder("device_id")}>Device Id</span>
                                    <Grid className="sort-icon-margin">
                                        <img src={sortColumn === "device_id" && sortOrder === "asc" ? ascSortingSelected : AscSort}
                                            className="ascendingOrderIcon sortingImages" onClick={() => handleColumnSort("device_id", "asc")}/>
                                        <img src={sortColumn === "device_id" && sortOrder === "desc" ? descSortingSelected : DescSort}
                                            className="sortingImages" onClick={() => handleColumnSort("device_id", "desc")}/>
                                    </Grid>
                                </span>
                            </TableCell>
                            <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell new-summary-left">
                                <span style={{ whiteSpace: "nowrap" }} className="align-items-center justifyContenetCenter">
                                    <span className="login-history-dp-name font-wt-900" onClick={() => toggleSortOrder("tail_id")}>Tail Number</span>
                                    <Grid className="sort-icon-margin">
                                        <img src={sortColumn === "tail_id" && sortOrder === "asc" ? ascSortingSelected : AscSort}
                                            className="ascendingOrderIcon sortingImages" onClick={() => handleColumnSort("tail_id", "asc")}/>
                                        <img src={sortColumn === "tail_id" && sortOrder === "desc" ? descSortingSelected : DescSort}
                                            className="sortingImages" onClick={() => handleColumnSort("tail_id", "desc")}/>
                                    </Grid>
                                </span>
                            </TableCell>
                            <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell new-summary-left">
                                <span style={{ whiteSpace: "nowrap" }} className="align-items-center justifyContenetCenter">
                                    <span className="login-history-dp-name font-wt-900" onClick={() => toggleSortOrder("source")}>Source</span>
                                    <Grid className="sort-icon-margin">
                                        <img src={sortColumn === "source" && sortOrder === "asc" ? ascSortingSelected : AscSort}
                                            className="ascendingOrderIcon sortingImages" onClick={() => handleColumnSort("source", "asc")}/>
                                        <img src={sortColumn === "source" && sortOrder === "desc" ? descSortingSelected : DescSort}
                                            className="sortingImages" onClick={() => handleColumnSort("source", "desc")}/>
                                    </Grid>
                                </span>
                            </TableCell>
                            <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell new-summary-left">
                                <span style={{ whiteSpace: "nowrap" }} className="align-items-center justifyContenetCenter">
                                    <span className="login-history-dp-name font-wt-900" onClick={() => toggleSortOrder("module")}>MODULE</span>
                                    <Grid className="sort-icon-margin">
                                        <img src={sortColumn === "module" && sortOrder === "asc" ? ascSortingSelected : AscSort}
                                            className="ascendingOrderIcon sortingImages" onClick={() => handleColumnSort("module", "asc")}/>
                                        <img src={sortColumn === "module" && sortOrder === "desc" ? descSortingSelected : DescSort}
                                            className="sortingImages" onClick={() => handleColumnSort("module", "desc")}/>
                                    </Grid>
                                </span>
                            </TableCell>
                            <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell new-summary-left">
                                <span style={{ whiteSpace: "nowrap" }} className="align-items-center justifyContenetCenter">
                                    <span className="login-history-dp-name font-wt-900" onClick={() => toggleSortOrder("description")}>DESCRIPTION</span>
                                    <Grid className="sort-icon-margin">
                                        <img src={sortColumn === "description" && sortOrder === "asc" ? ascSortingSelected : AscSort}
                                            className="ascendingOrderIcon sortingImages" onClick={() => handleColumnSort("description", "asc")}/>
                                        <img src={sortColumn === "description" && sortOrder === "desc" ? descSortingSelected : DescSort}
                                            className="sortingImages" onClick={() => handleColumnSort("description", "desc")}/>
                                    </Grid>
                                </span>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        { flightTailNumberUpdateTable && 0 != flightTailNumberUpdateTable.length ? 
                        <TableBody className="tableBody alertsTable-tableBody">
                            {flightTailNumberUpdateTable.map((row: any, index: number)=> (
                            <TableRow className="alertsData-tabelRow">
                                <TableCell className="alertsTable-tableCell">{convertDateTimeIntoTimezone(row.ts, authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS)}</TableCell>
                                <TableCell className="alertsTable-tableCell">{row.device_id}</TableCell>
                                <TableCell className="alertsTable-tableCell">{row.tail_id}</TableCell>
                                <TableCell className="alertsTable-tableCell">{row.source}</TableCell>
                                <TableCell className="alertsTable-tableCell">{row.module}</TableCell>
                                <TableCell className="alertsTable-tableCell">{row.description}</TableCell>
                            </TableRow>
                            ))}
                        </TableBody> : 
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={8} align='center'>
                                    No data available
                                </TableCell>
                            </TableRow>
                        </TableBody>}
                    </Table>
                </TableContainer>
            </Grid>
            <FlightSchedule selectedVessel={selectedVessel} selectedVesselName={selectedVesselName}/>
        </Grid>
    )
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    newSummaryStartDate: state?.authReducer?.newSummaryStartDate,
    newSummaryEndDate: state?.authReducer?.newSummaryEndDate,
    flightTailIdUpdateTable: state.authReducer?.flightTailIdUpdateTable,
    flightTailIdUpdateTableCount: state.authReducer?.flightTailIdUpdateTableCount
});

export default withRouter(
    connect(mapStateToProps, {
        getFlightTailIdUpdateData,
        getFlightTailIdUpdateDataCount
    })(FlightsComponent)
);